import { IReferralForm } from "./interfaces/referral-form";
import { IReferralFormQuestionGroup } from "./interfaces/referral-form-question-group";

export class ReferralForm implements IReferralForm {
  constructor(
    referralFormId: number = 0,
    name?: string,
    description?: string,
    referralFormTypeId: number = 0,
    version: number = 1,
    isDeleted: boolean = false,
    index: number = 1,
    active: boolean = false,
    createdOn?: Date,
    referralFormQuestionGroups: IReferralFormQuestionGroup[] = []
  ) {
    this.isDeleted = isDeleted;
    this.version = version;
    this.referralFormTypeId = referralFormTypeId;
    this.name = name === undefined ? '' : name;
    this.description = description === undefined ? '' : description;
    this.referralFormId = referralFormId;
    this.index = index;
    this.active = active;
    this.createdOn = createdOn ? createdOn : new Date();
    this.referralFormQuestionGroups = referralFormQuestionGroups;
  }

  referralFormId: number;
  name: string;
  description: string;
  referralFormTypeId: number;
  version: number;
  isDeleted: boolean;
  index: number;
  active: boolean;
  thresholdScore: number;
  createdOn: Date;

  referralFormQuestionGroups: IReferralFormQuestionGroup[];

  prepare(): void {
    if (this.index < 1) {
      this.index = 1;
    }

    if (this.version < 1) {
      this.version = 1;
    }

    if (this.referralFormQuestionGroups.length > 0) {
      for (let i = 0; i < this.referralFormQuestionGroups.length; i++) {
        this.referralFormQuestionGroups[i].index = i + 1;
      }

      this.referralFormQuestionGroups.forEach(rf => {
        rf.prepare();
      });
    }
  }

  isValid(): boolean {

    let valid = (this.name === null || this.name === undefined) ? false : (this.description === null || this.description === undefined) ? false : (this.referralFormTypeId > 0) ? (this.index > 0) ? (this.version > 0) ? true : false : false : false;

    return valid;
  }
}
